import styled, { createGlobalStyle } from 'styled-components';

import MainContent from '../../components/layout/MainContent';

export const LayoutGlobalStyles = createGlobalStyle`
  body {
    overlow-x: hidden;
  }
`;

export const StyledApplicationLayout = styled.div<{
  $minHeight: string;
}>`
  position: relative;
  font-family: ${({ theme }) => theme.fontFamily.regular};
  color: ${({ theme }) => theme.colors.text};
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  display: flex;
  min-height: ${({ $minHeight }) => $minHeight};
  flex-direction: column;
  /* Fix for IE11 */
  height: 1px;

  > * {
    flex-shrink: 0;
  }
`;

export const StyledMainContent = styled(MainContent)`
  flex-grow: 1;
`;
